<script setup lang="ts">
import type {BenefitItem} from '~/types/legacy'
import type {Populated} from '~/types/populated'
import Heading from '../ui/heading.vue'

const props = defineProps<{
  data: Populated<BenefitItem>
}>()
</script>

<template>
  <div
    class="group cursor-pointer space-y-8 border-2 border-transparent p-4 transition-all duration-300 ease-in-out hover:border-main-500 hover:bg-main-50"
  >
    <div class="inline-flex h-16 w-16 items-center justify-center rounded-full bg-main-50">
      <div
        class="flex h-12 w-12 items-center justify-center rounded-full bg-main-100 text-main-700 transition-all duration-300 ease-in-out group-hover:bg-main-500 group-hover:text-white"
      >
        <Icon class="h-6 w-6" :name="props.data.icon!" />
      </div>
    </div>
    <div>
      <Heading as="h3" size="small">{{ props.data.title }}</Heading>
      <Paragraph> {{ props.data.description }}</Paragraph>
    </div>
  </div>
</template>
